import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingLoginComponent } from './landing-login-component';

export const LandingLoginRoutes: Routes = [
    {
        path: '',
        component: LandingLoginComponent
    }
];
@NgModule({
    imports: [RouterModule.forChild(LandingLoginRoutes)],
    exports: [RouterModule],
    providers: []
})
export class LandingLoginRoutingModule { }